import React from "react";
import { useEffect } from "react";
export default function Contact() {
  useEffect(() => {
    document.title = "Contact Us";
  }, []);
  const breadcrumbItems = [
    {
      label: (
        <>
          <i className="bi bi-house"></i> Home
        </>
      ),
      link: "/",
    },
    {
      label: "Contact Us",
      link: "/contact",
    },
  ];
  return (
    <div className="contact-modern-page">
      {/* HERO */}
      <section className="contact-hero">
        <div className="contact-hero-content">
          <h1>Get In Touch</h1>
          <p>
            We're here to help with embroidery designs, membership, downloads,
            and technical support.
          </p>
        </div>
      </section>

      {/* CONTACT CARDS */}

      <section className="contact-info-section">
        <div className="contact-grid">
          {/* DIRECT SUPPORT */}

          <div className="contact-card">
            <div className="contact-icon">
              <i className="bi bi-person-lines-fill"></i>
            </div>

            <h3>Direct Support</h3>

            <div className="contact-item">
              <span>Haresh H. Vaddoriya</span>
              <a href="tel:+919879196990">+91 98791 96990</a>
            </div>

            <div className="contact-item">
              <span>Hitesh H. Vaddoriya</span>
              <a href="tel:+919909614445">+91 99096 14445</a>
            </div>
          </div>

          {/* CUSTOMER CARE */}

          <div className="contact-card">
            <div className="contact-icon">
              <i className="bi bi-headset"></i>
            </div>

            <h3>Customer Care</h3>

            <a href="tel:+918980995007" className="contact-link">
              +91 89809 95007
            </a>
          </div>

          {/* EMAIL */}

          <div className="contact-card">
            <div className="contact-icon">
              <i className="bi bi-envelope-fill"></i>
            </div>

            <h3>Email Us</h3>

            <a
              href="mailto:lifetime.ltc0777@gmail.com"
              className="contact-link"
            >
              lifetime.ltc0777@gmail.com
            </a>

            <a href="mailto:hareshvaddoriya@gmail.com" className="contact-link">
              hareshvaddoriya@gmail.com
            </a>
          </div>

          {/* ADDRESS */}

          <div className="contact-card">
            <div className="contact-icon">
              <i className="bi bi-geo-alt-fill"></i>
            </div>

            <h3>Office Address</h3>

            <p>
              Shop-17, UP GR Floor, <br />
              Ranuja Complex, <br />
              Nr- Riddhi Siddhi School,
              <br /> Vallabhacharya Road, Ashvani Kumar, <br />
              Surat-395008 Gujarat, India
            </p>
          </div>
        </div>
      </section>

      {/* MAP */}

      <section className="map-section">
        <iframe
          title="Location Map"
          src="https://maps.google.com/maps?q=surat%20varachha&t=&z=13&ie=UTF8&iwloc=&output=embed"
          allowFullScreen
          loading="lazy"
        />
      </section>
    </div>
  );
}
